export default __webpack_public_path__ + "static/media/routinely2.0bb52932.png";